import { render, staticRenderFns } from "./ContentDescriptionBlock.vue?vue&type=template&id=30598cb9&scoped=true&"
import script from "./ContentDescriptionBlock.vue?vue&type=script&lang=js&"
export * from "./ContentDescriptionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30598cb9",
  null
  
)

export default component.exports